<template>
  <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目" prop="project">
            <el-input v-model="form.project" placeholder="请输入项目名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产生时间" prop="occurrenceTime">
            <el-date-picker v-model="form.occurrenceTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" 
                            placeholder="选择产生时间" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="反应时长(分钟)" prop="responseDuration">
            <el-input-number v-model="form.responseDuration" :min="0" :max="9999" placeholder="请输入反应时长" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="责任人" prop="responsiblePerson">
            <el-input v-model="form.responsiblePerson" placeholder="请输入责任人姓名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="事件内容" prop="incidentContent">
            <el-input v-model="form.incidentContent" type="textarea" :rows="6" placeholder="请详细描述事件内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :loading="loading">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {queryEmergencyIncidentDetail, addEmergencyIncident, updateEmergencyIncident} from "@/api/crm/emergencyIncident";

export default {
  name: "EmergencyIncidentDialog",
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否为编辑模式
      isEdit: false,
      // 提交loading
      loading: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        project: [
          {required: true, message: "项目名称不能为空", trigger: "blur"},
          {min: 1, max: 255, message: "项目名称长度在1到255个字符之间", trigger: "blur"}
        ],
        occurrenceTime: [
          {required: true, message: "产生时间不能为空", trigger: "blur"}
        ],
        responseDuration: [
          {required: true, message: "反应时长不能为空", trigger: "blur"},
          {type: 'number', min: 0, max: 9999, message: "反应时长必须为0-9999之间的数字", trigger: "blur"}
        ],
        responsiblePerson: [
          {required: true, message: "责任人不能为空", trigger: "blur"},
          {min: 1, max: 100, message: "责任人长度在1到100个字符之间", trigger: "blur"}
        ],
        incidentContent: [
          {required: true, message: "事件内容不能为空", trigger: "blur"},
          {min: 1, max: 2000, message: "事件内容长度在1到2000个字符之间", trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    // 打开对话框
    openDialog(id) {
      this.reset();
      this.open = true;
      
      if (id) {
        this.isEdit = true;
        this.title = "修改应急处理事件进展";
        this.getDetail(id);
      } else {
        this.isEdit = false;
        this.title = "新增应急处理事件进展";
      }
    },
    
    // 获取详情
    getDetail(id) {
      queryEmergencyIncidentDetail({id}).then(response => {
        this.form = response.data;
      });
    },
    
    // 表单重置
    reset() {
      this.form = {
        id: null,
        project: null,
        occurrenceTime: null,
        responseDuration: null,
        responsiblePerson: null,
        incidentContent: null
      };
      this.resetForm("form");
    },
    
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    
    // 表单提交
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true;
          
          const submitFn = this.isEdit ? updateEmergencyIncident : addEmergencyIncident;
          submitFn(this.form).then(() => {
            this.$message.success(this.isEdit ? "修改成功" : "新增成功");
            this.open = false;
            this.$emit("success");
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    }
  }
};
</script>